const o=()=>{},t=o=>o;export{o as noop,t as noopReturn};
